import { InternalRoleSchema } from '@buyerflo/core/schemas/roles'
import Button from 'components/button'
import { SizableText, View, XStack, YStack } from 'tamagui'
import { useRolesApi, useUsersApi } from 'apiProviders'
import { useUserData } from 'auth'
import Loading from 'components/Loading'
import Modal, { dontCloseOnBackgroundClick } from 'components/modal'
import SectionHead from 'components/sectionHead'
import { sortBy } from 'ramda'
import { useState } from 'react'
import { EditRoleModal } from './editRoleModal'

const RolesPage = () => {
    const usersApi = useUsersApi()
    const rolesApi = useRolesApi()
    const { user } = useUserData()

    const [editRole, setEditRole] = useState<{} | InternalRoleSchema | undefined>()

    return (
        <View
            paddingHorizontal="$4"
            $sm={{ paddingHorizontal: '$6' }}
        >
            <SectionHead title="Roles" />
            {rolesApi.data ? (
                    <View maxWidth={640}>
                        <YStack gap="$3">
                            {sortBy(role => role.roleName.toLowerCase(), rolesApi.data).map(role => (
                                <View
                                    key={role.id}
                                    borderWidth={1}
                                    borderColor="$borderColor"
                                    borderRadius="$3"
                                    padding="$4"
                                    backgroundColor="$backgroundStrong"
                                    cursor="pointer"
                                    animation="quick"
                                    hoverStyle={{
                                        backgroundColor: '$backgroundHover',
                                    }}
                                    pressStyle={{
                                        backgroundColor: '$backgroundPress',
                                        opacity: 0.85,
                                    }}
                                    onPress={() => setEditRole(role)}
                                >
                                    <XStack gap="$4" alignItems="flex-start" flex={1}>
                                        <SizableText fontWeight="600">
                                            {role.roleName}
                                        </SizableText>
                                        <View flex={1} />
                                        <XStack flexWrap="wrap" gap="$1">
                                            {(usersApi.data ?? [])
                                                .filter(user => user.roleId == role.id)
                                                .map(user => (
                                                    <View
                                                        key={user.userId}
                                                        backgroundColor="$primaryLight"
                                                        paddingHorizontal="$2"
                                                        paddingVertical="$0.5"
                                                        borderRadius={999}
                                                    >
                                                        <SizableText fontSize="$2">
                                                            {user.firstName} {user.lastName}
                                                        </SizableText>
                                                    </View>
                                                ))}
                                        </XStack>
                                    </XStack>
                                </View>
                            ))}
                        </YStack>
                        {user.permissions.includes('roles.edit') && (
                            <Button
                                marginTop="$4"
                                theme="primary"
                                onPress={() => setEditRole({})}
                                animation="quick"
                                data-help-id="roles-new-button"
                            >
                                New Role
                            </Button>
                        )}
                    </View>
                ) : (
                    <Loading />
                )}
            <Modal
                open={editRole !== undefined}
                onOpenChange={(open) => { if (!open) setEditRole(undefined) }}
            >
                {usersApi.data
                    ? editRole && (
                              <EditRoleModal
                                  role={editRole}
                                  users={usersApi.data!}
                                  close={() => setEditRole(undefined)}
                              />
                          )
                    : <Loading />}
            </Modal>
        </View>
    )
}

export default RolesPage
